<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <base-button
        type="primary"
        round
        icon
        class="top-button-back"
        @click="$router.push('list')"
      >
        <i class="fa fa-arrow-left"></i>
      </base-button>

      <h2 class="text-center">Edit User</h2>
    </div>
       <div class="row">
      <div class="col-md-8">
        <card>
          <form onSubmit="return false;">
            <div class="row">
              <div class="col-md-6">
                <base-input
                  type="text"
                  label="First Name "
                  placeholder="First Name"
                  v-model="first_name"
                >
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  type="text "
                  label="Last Name"
                  placeholder="Last Name"
                  v-model="last_name"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  type="email"
                  label="Email"
                  placeholder="Email"
                  v-model="email"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  type="text"
                  label="Address"
                  placeholder="Address"
                  v-model="address"
                ></base-input>
              </div>

              <div class="col-md-6">
                <label>gender</label>
                <select
                  class="location form-control"
                   v-model="gender"
                  style="width:100%; color:white !important;"
                >
                  <option
                    style="color:black !important;"
                    v-for="env in genders"
                    v-bind:key="env"
                    >{{ env }}</option
                  >
                </select>
              </div>
              <div class="col-md-6">
                <base-input
                  type="tel"
                  label="Phone Number"
                  placeholder="Phone Number"
                  v-model="phone_number"
                >
                </base-input>
              </div>

            </div>

			<hr>

            <base-button
              native-type="submit"
              type="primary"
              @click="UpdateUser()"
              value="Compares"
              class="btn-fill"
              :disabled="loading"
              >Update User</base-button
            >
          </form>
        </card>
      </div>

    </div>
    <div class="row">

      <div class="col-md-12">
        <base-button v-if="!this.is_block" type="primary" @click="blockUser()" class="btn-fill"> Block User
        </base-button>
        <base-button v-if="this.is_block" type="primary" @click="blockUser()" class="btn-fill"> Unblock User
        </base-button>
      </div>
    </div>
    <div class="row">
      <hr>
    </div>
      <h3>Edit Vaccine Status</h3>
       <base-button
          type="primary"
          round
          icon
          class="top-button-delete float-right"
          @click="deleteUser()"
        >
          <i class="fa fa-trash"></i>
        </base-button>
      <div class="row left-spacer" style="display: flex">
        <div class="col-md-2">
        <base-checkbox v-model="isVaccinated">Is Vaccinated</base-checkbox>
        </div>
        <base-button
            type="primary"
            class="top-button-delete"
            @click="saveVaccineStatus()"
          >save</base-button>
      </div>
        <div class="row">
      <hr>
    </div>

    <div class="row">
      <div class="col-md-4">
        <label class="readable-label">Add/Deduct Credits</label>
        <div style="display: flex;">
          <base-input
              type="number"
              placeholder="Credits"
              v-model.number="addmoney"
              :min="1"
          >
          </base-input>
          <base-button
            type="primary"
            round
            icon
            class="top-button"
            @click="addCredits()"
          >
          <i class="fa fa-plus"></i>
          </base-button>
          <base-button
            type="danger"
            round
            icon
            class="top-button"
            @click="deductCredits()"
          >
          <i class="fa fa-minus"></i>
          </base-button>
        </div>
        <div ><h5>Total Credits Balance : <b>{{this.credits}}</b> </h5></div>
      </div>
    </div>
    
    <!-- <div class="row">
      <hr />
    </div>
    <div class="row">
      <div class="col-md-4">
        <label class="readable-label">Add Pass</label>
        <div style="display: flex;">
          <select
            v-model="new_pass"
            class="location form-control"
            style="width:100%; color:white !important;"
          >
            <option
              style="color:black !important;"
              v-for="pass in pass_types"
              v-bind:key="pass.name"
              >{{ pass.name }}</option
            >
          </select>
          <base-button
            type="primary"
            round
            icon
            class="top-button"
            @click="addPass()"
          >
            <i class="fa fa-plus"></i>
          </base-button>
        </div>
      </div>
      <div class="col-md-2"></div>
      <div class="col-md-6" />
    </div>
    <div class="spacer" />
    <h3 class="text-left">User's Passes</h3>
    <div class="row">
      <el-table :data="queriedData" class="small">
        <el-table-column align="left" label="Pass Name">
          <div slot-scope="props">
            <div style="display: flex">
              <div>
                <div>{{ props.row.pass_name }}</div>
              </div>
            </div>
          </div>
        </el-table-column>

        <el-table-column align="left" label="Balance" max-width="50">
          <div slot-scope="props">
            <div>
              <div>{{ props.row.balance }}</div>
            </div>
          </div>
        </el-table-column>
        <el-table-column align="left">
          <div slot-scope="props">
            <button class="btn btn-fill" @click="deletePass(props.row)">
              Remove
            </button>
          </div>
        </el-table-column>
      </el-table>
    </div> -->

    <div class="full-screen-loader" v-if="loading">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { BaseCheckbox, BaseRadio } from "src/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";

export default {
  components: {
    BaseRadio,
    BaseCheckbox,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table
  },
  data() {
    return {
      pass_types: [],
      user_passes: [],
      new_pass: null,
      credits: 0,
      addmoney: 0,
      user: null,
      loading: false,
      isVaccinated: null,
      first_name : "",
      last_name : "",
      email : "",
      phone_number : "",
      gender : "",
      address : "",
      genders : ["male","female"],
      is_block : false
    };
  },

  async mounted() {
    let user_id = this.$route.query.user_id;
    console.log("Mount edit user " + user_id);

    // let pass_response = await this.$apiService.getCall("pass/passes");
    // this.pass_types = pass_response.apidata.Data || [];
    let user_response = await this.$apiService.getCall(
      "user/userbyId/" + user_id
    );
    this.user = user_response.apidata.Data || null;
    console.log(this.user)
    this.first_name = this.user.first_name
    this.last_name = this.user.last_name
    this.email = this.user.email
    this.phone_number = this.user.phone_number
    this.gender = this.user.gender
    this.address = this.user.address
    this.is_block = this.user.is_block || false;
    this.credits = this.user.dropin_money || 0;


    // let user_pass_response = await this.$apiService.getCall(
    //   "userpass/all-user-pass/" + user_id
    // );
    // this.user_passes = user_pass_response.apidata.Data || [];
    if(this.user.vaccinated == undefined) {
      this.isVaccinated = false;
    } else {
      this.isVaccinated = this.user.vaccinated;
    }

    var _self = this;
  },
  methods: {
    async UpdateUser() {
      let user_id = this.$route.query.user_id;
      console.log("Update User");

      let updateUser = await this.$apiService.postCall(
        "user/update-by-id",{
          id: user_id,
          first_name : this.first_name,
          last_name : this.last_name,
          email : this.email,
          phone_number : this.phone_number,
          gender : this.gender,
          address : this.address,
        }
      );

      if (!updateUser.isError) {
        console.log("success");
        if (updateUser.apidata.Code == 'P00001') {
          this.$apiService.notify("The user updated successfully!");
        } else {
          if (updateUser.apidata.Code == 'ACC003') {
            this.$apiService.notify("Email id is already exists");
          } else if (updateUser.apidata.Code == 'ACC008') {
            this.$apiService.notify("Phone number is already exists");
          } else if (updateUser.apidata.Code == 'ACC006') {
            this.$apiService.notify("User does not exist");
          } else if (updateUser.apidata.Code == 'ACC009') {
            this.$apiService.notify("Please provide a valid email address");
          } else if (updateUser.apidata.Code == 'ACC010') {
            this.$apiService.notify("The phone number must contain only numeric 10 digits");
          } else {
            this.$apiService.notify("error while user updated");
          }
        }
      } else {
        console.log("error");
      }
    },

  //  async deletePass(userPass) {
  //     console.log("delete ");
  //     console.log(userPass);
  //     let deleted_pass = {
  //       user_id: this.user._id,
  //       pass_id: userPass.pass_id
  //     };
  //     console.log(deleted_pass);
  //     let delete_response = await this.$apiService.postCall(
  //       "userpass/delete-userpass",
  //       deleted_pass
  //     );
  //     if (!delete_response.isError) {
  //       let user_pass_response = await this.$apiService.getCall(
  //         "userpass/all-user-pass/" + this.user._id
  //       );
  //       this.user_passes = user_pass_response.apidata.Data || [];
  //       console.log(this.user_passes);
  //     }
  //   },
  //   async addPass() {
  //     console.log(this.new_pass);
  //     let pass_type = this.pass_types.find(pass => pass.name == this.new_pass);

  //     console.log(this.user);
  //     let newPassOrder = {};
  //     newPassOrder.quantity = pass_type.game_count;
  //     newPassOrder.user_id = this.user._id;
  //     newPassOrder.pass_id = pass_type._id;
  //     newPassOrder.type = "CREDIT";
  //     console.log(newPassOrder);
  //     let add_response = await this.$apiService.postCall(
  //       "userpass/add-userpass",
  //       newPassOrder
  //     );
  //     console.log(add_response);
  //     if (!add_response.isError) {
  //       let user_pass_response = await this.$apiService.getCall(
  //         "userpass/all-user-pass/" + this.user._id
  //       );
  //       this.user_passes = user_pass_response.apidata.Data || [];
  //       console.log(this.user_passes);
  //     }
  //   },

    async addCredits() {
      console.log("ADD DM",this.addmoney);
      console.log("USER",this.user);
      if (!this.addmoney || this.addmoney <= 0) {
        this.$apiService.notify("Please enter an amount greater than zero.");
        this.addmoney = null;
        return;
      }
      let creditsBody = {
        dropin_money: this.addmoney,
        user_id: this.user._id
      };
      console.log(creditsBody);
      let add_response = await this.$apiService.postCall(
        "userdropinmoney/add-user-dropin-money",
        creditsBody
      );
      console.log(add_response);
      if (!add_response.isError) {
        if (add_response.apidata.Code == 'P00001') {
          this.$apiService.notify("Successfully added credits.");
        } else {
          this.$apiService.notify(add_response.apidata.Message);
        }
        this.addmoney = null;

        let user_response = await this.$apiService.getCall(
          "user/userbyId/" + this.user._id
        );
        this.user = user_response.apidata.Data || [];
        this.credits = this.user.dropin_money || 0;
      }
    },

    async deductCredits() {
      console.log("Deduct Credits",this.addmoney);
      console.log("USER",this.user);
      if (!this.addmoney || this.addmoney <= 0) {
        this.$apiService.notify("Please enter an amount greater than zero.");
        this.addmoney = null;
        return;
      }
      if (this.user.dropin_money < this.addmoney) {
        this.$apiService.notify("Insufficient balance for this user, so you can't deduct credits.");
        this.addmoney = null;
        return;
      }
      let creditsBody = {
        dropin_money: this.addmoney,
        user_id: this.user._id
      };
      console.log(creditsBody);
      let add_response = await this.$apiService.postCall(
        "userdropinmoney/deduct-user-dropin-money",
        creditsBody
      );
      console.log(add_response);
      if (!add_response.isError) {
        if (add_response.apidata.Code == 'P00001') {
          this.$apiService.notify("Successfully deducted credits.");
        } else {
          this.$apiService.notify(add_response.apidata.Message);
        }
        this.addmoney = null;

        let user_response = await this.$apiService.getCall(
          "user/userbyId/" + this.user._id
        );
        this.user = user_response.apidata.Data || [];
        this.credits = this.user.dropin_money || 0;
      }
    },
    
    async deleteUser() {
      console.log("deleting user");
      console.log(this.user);

      let delete_response = await this.$apiService.postCall(
        "user/delete-user/" + this.user._id
      );
      console.log(delete_response);
      if (!delete_response.isError) {
        this.$router.push("list");
      }
    },
    async updateVaccinationStatus(status) {
      console.log("updating user vaccination status");
      let newVaccinationStatus = {};
      newVaccinationStatus.id = this.user._id;
      newVaccinationStatus.vaccinated = status;
      console.log(newVaccinationStatus);
      let updateReponse = await this.$apiService.postCall(
        "user/set-vaccine-status",
        newVaccinationStatus
      );

      if (!updateReponse.isError) {
        console.log("success");
        this.$apiService.notify("The user updated successfully!");
      } else {
        console.log("error");
      }
    },
    getVaccineStatus(user) {
      if (user.vaccinated == true) {
        return "vaccinated";
      } else if (user.vaccine_proof_img == null || user.vaccine_proof_img == undefined) {
        return "Pending photo proof";
      } else if (user.vaccine_proof_img != "") {
        return "Pending admin approval";
      } else if (user.vaccinated == false) {
        return "Rejected. Pending new proof";
      }
    },
    saveVaccineStatus() {
      console.log("toggle");
      if(this.isVaccinated == undefined) {
        this.isVaccinated = false;
      }
      console.log(this.isVaccinated);
      this.updateVaccinationStatus(this.isVaccinated);
    },
    async blockUser() {
      let isConfirmed = confirm(`Are you sure want to ${this.is_block ? "Unblock" : "Block"} this user?`);
      if (isConfirmed) {
        this.loading = true;
        let user_id = this.$route.query.user_id;
        let res = await this.$apiService.postCall("user/user-block/" + user_id);
        console.log("block user response",res)
        if (res.apidata.Code == 'P00001') {
          this.is_block = res.apidata.Data.is_block
          this.$apiService.notify(res.apidata.Message);
        } else {
          this.$apiService.notify('Something went wrong');
        }
        this.loading = false;
      }
    }
  },
  computed: {
    queriedData() {
      return this.user_passes.filter(pass => pass.balance > 0);
    }
  }
};
</script>
<style>
.spacer {
  height: 30px;
}
.location {
  background: #27293d !important;
  border: 1px solid #2b3553;
  padding: 8px;
  font-size: 14px;
  border-radius: 5px;
  width: 100%;
  color: white;
}
.user-info {
  margin-bottom: 15px;
}
.user-info-block {
  display: block;
  margin-left: 15px;
}
.left-spacer {
  margin-left: 15px;
}
form label {
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
}

.coordinate {
  background: #27293d;
  border: 1px solid #2b3553;
  padding: 5px;
  font-size: 14px;
  border-radius: 5px;
  /* width: 100%; */
  color: white;
}
.radio-item input[type="radio"]:checked + label:after {
  border-radius: 11px;
  width: 12px;
  height: 12px;
  position: absolute;
  top: 9px;
  left: 19px;
  content: " ";
  display: block;
  background: #e14eca;
}
.radio-item {
  display: inline-block;
  position: relative;
  padding: 0 15px;
  margin: 10px 0 0;
}

.radio-item input[type="radio"] {
  display: none;
}

.radio-item label {
  color: white;
  font-weight: 600;
}

.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  margin: 0 5px 0 0;
  width: 20px;
  height: 20px;
  border-radius: 11px;
  border: 2px solid white;
  background-color: transparent;
}
</style>
